import { DriverFilters } from "../model/driver";
import {
  Http,
  Response,
  Headers,
  Request,
  RequestOptions,
} from "@angular/http";
import { throwError as observableThrowError, Observable } from "rxjs";
import { AuthHeaderService } from "../views/authheader.service";
import { environment } from "../../environments/environment";
import { Injectable } from "@angular/core";
import { map, catchError } from "rxjs/operators";

@Injectable()
export class FuelChargeService {
  fuelchargeurl: string;
  fuelexpenseurl :string;
  updateFuelExpenseUrl: string;
  constructor(private http: Http, private _headerService: AuthHeaderService) {
    this.fuelchargeurl = environment.fuelchargeurl;
    this.fuelexpenseurl = environment.fuelexpenseurl;
    this.updateFuelExpenseUrl = environment.updateFuelExpenseUrl;
  }
  SendForm = (pageFilters: any) => {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(this.fuelchargeurl, pageFilters, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  };

  deleteFuelCharge(fuelcharge) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    const id = fuelcharge._id;
    return this.http.delete(this.fuelchargeurl + "/" + id, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getFuelChargeData() {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.fuelchargeurl, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getFuelExpenseData() {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(this.fuelexpenseurl,{}, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getFuelChargeByMerchant(merchantId) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.fuelchargeurl + "/" + merchantId, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  editFuelCharge = (obj, id) => {
    delete obj["_id"];
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    var newobj = {};
    return this.http.put(this.fuelchargeurl + "/" + id, obj, options).pipe(
      map((response) => {
        return response.json();
      }),
      catchError((error: Response) => {
        console.log(error);
        return observableThrowError(error);
      })
    );
  };

  editpartialFuelCharge = (obj) => {
    delete obj["_id"];
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    var newobj = {};
    return this.http.patch(this.updateFuelExpenseUrl , obj, options).pipe(
      map((response) => {
        return response.json();
      }),
      catchError((error: Response) => {
        console.log(error);
        return observableThrowError(error);
      })
    );
  };
  cancelFuelCharge(obj) {
    let option = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(this.fuelchargeurl + "/cancel", obj, option).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  fuelExpense() {
    let option = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.fuelchargeurl + "/fuelexpense", option).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  fuelExpensePerMile() {
    let option = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.fuelchargeurl + "/fuelexpensepermile", option).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getFuelChargeBillsByIds(ids: string[]){
    //let params = new HttpParams();
    //console.log("hit");
    let params =  ids.join(',');
    let options = new RequestOptions({headers: this._headerService.getHeader(), params : params});
    return this.http.get(this.fuelchargeurl + '/billListForIds/' + params, options).pipe(map(response => response.json().data ? [] : response.json()), catchError((error: Response) => { return observableThrowError(error); }));
}

  getExternalFuelCardTransactions(queryParams: {cardNumbers: string, fromDate?:string, toDate?:string}) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
      params: queryParams,
    });
    return this.http.get(`${this.fuelchargeurl}/external`, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
}
